<template>
    <div class="apn-page apn-home">
        <!-- Banner -->
        <apn-home-banner />
        <!-- Main -->
        <section class="section section--loading" v-show="loading">
            <div class="lds-css ng-scope">
                <div style="width:100%;height:100%" class="lds-ellipsis">
                    <div><div></div></div>
                    <div><div></div></div>
                    <div><div></div></div>
                    <div><div></div></div>
                    <div><div></div></div>
                </div>
            </div>
        </section>
        <!-- <section class="section section--promotions" v-show="true">
            <div class="apn-container">
                <h1>promotion</h1>
                <article class="promotions">
                    <div class="promotion" v-for="i in 2" :key="i">
                        <h2>{{$i18n.locale === 'en' ? promotion.title : promotion.mm_title}}</h2>
                        <small>{{$i18n.locale === 'en' ? promotion.sub_title : promotion.mm_sub_title}}</small>
                        <p>{{$i18n.locale === 'en' ? promotion.description : promotion.mm_description}}</p>
                    </div>
                </article>
            </div>
        </section> -->
        <section class="section section--services">
            <div class="apn-container">
                <h1>our services</h1>
                <article class="services">
                    <div class="service service--plans">
                        <h2>FTTH iPLANS</h2>
                        <p>{{$t('home.broadband')}}</p>
                        <button @click="viewOffer('plans')" class="apn-btn--more">view</button>
                    </div>
                    <div class="service service--business">
                        <h2>BUSINESS INTERNET</h2>
                        <p>{{$t('home.features')}}</p>
                        <button @click="viewOffer('business')" class="apn-btn--more">view</button>
                    </div>
                    <div class="service service--access">
                        <h2>DEDICATED INTERNET ACCESS</h2>
                        <p>{{$t('home.dedicated')}}</p>
                        <button  @click="viewOffer('access')" class="apn-btn--more">view</button>
                    </div>
                </article>
            </div>
        </section>
        <section class="section sectin--contact">
            <div class="contact-background"></div>
            <div class="apn-container">
                <div class="box">
                    <h2>feel the speed at your finger tips</h2>
                    <p>
                        Our in house best in class routing technology allowed the users to enjoy the ultimate experience with no limitation.
                        Ultra-fast speed with premium customer services, just for you. 
                    </p>
                    <router-link to="/contact" class="apn-btn--more">order now</router-link>
                </div>
            </div>
        </section>
        <!-- Footer -->
        <apn-footer />
    </div>
</template>

<script>
import { mapState, mapActions } from "vuex"
import ApnHomeBanner from '@/components/ApnHomeBanner'
import ApnFooter from '@/components/ApnFooter'

export default {
    name: 'ApnHome',
    components: {
        ApnHomeBanner,
        ApnFooter,
    },
    computed: {
        ...mapState({
            promotions: state => state.promotions,
            loading: state => state.loading,
        })
    },
    methods: {
        ...mapActions({
            setPlan: 'setPlan',
            getPromotions: 'getPromotions',
        }),
        viewOffer(tab) {
            this.setPlan(tab)
            this.$router.push('/plans')
        },
    },
    mounted() {
        this.getPromotions()
    },
}
</script>

<style lang="scss" scoped>
.apn-home {
    margin-top: var(--header-height);

    .apn-btn--more {
        font-size: 1rem;
    }
            
    .section {
        padding: 40px 0;
        .apn-container {
            h1 {
                text-transform: uppercase;
                font-size: 42px;
                font-weight: 300;
                text-align: center;
                padding: 40px 0 20px;
                color: var(--primary);
                @media (min-width: 992px) {
                    font-size: 54px;
                }
            }
        }
    }
    .section--loading {
        width: 100%;
        height: 500px;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .section--promotions {
        .promotions {
            display: flex;
            flex-wrap: wrap;
            justify-content: center;
            align-items: flex-start;
            .promotion {
                width: 100%;
                display: flex;
                flex-direction: column;
                justify-content: flex-start;
                align-items: center;
                padding: 20px;
                max-width: 500px;
                @media (min-width: 992px) {
                    width: 50%;
                    max-width: 600px;
                }
                &::before {
                    content: '';
                    width: 80px;
                    height: 80px;
                    display: block;
                    margin: 20px;
                    background-image: url(../assets/icons/flyers.png);
                    background-size: contain;
                    background-position: center;
                    background-repeat: no-repeat;
                }
                h2 {
                    text-transform: uppercase;
                    text-align: center;
                    font-size: 20px;
                }
                p {
                    text-align: center;
                }
            }
        }   
    }
    .section--services {
        background-color: var(--theme-bg);
        .services {
            display: flex;
            flex-wrap: wrap;
            justify-content: center;
            align-items: flex-start;
            .service {
                width: 100%;
                display: flex;
                flex-direction: column;
                justify-content: flex-start;
                align-items: center;
                padding: 20px;
                max-width: 500px;

                @media (max-width: 991.9px) {
                    &.service--business, &.service--plans, &.service--access {
                        background: #fff;
                        margin: 15px 0;
                        padding-bottom: 40px;
                    }
                }
                @media (min-width: 992px) {
                    width: 33.33%;
                    max-width: 500px;
                }
                &::before {
                    content: '';
                    width: 76px;
                    height: 76px;
                    display: block;
                    margin: 20px;
                    background-size: contain;
                    background-position: center;
                    background-repeat: no-repeat;
                }
                &.service--plans::before {
                    background-image: url(../assets/icons/ftth.svg);
                    background-size: 100px;
                }
                &.service--access::before {
                    background-image: url(../assets/icons/dia.svg);
                    background-size: 100px;
                }
                &.service--business::before {
                    background-image: url(../assets/icons/business.svg);
                    background-size: 100px;
                }
                h2 {
                    text-align: center;
                    font-size: 20px;
                    padding-bottom: 0;
                }
                p {
                    text-align: center;
                    margin-bottom: 20px;
                    @media (min-width: 992px) {
                        margin-bottom: 0;
                        min-height: 125px;
                    }
                }
            }
        }
    }
    .sectin--contact {
        @media (max-width: 991.9px) {
            padding: 0;
        }
        @media (min-width: 992px) {
            position: relative;
            height: 550px;
        }
        .contact-background {
            width: 100%;
            height: 260px;
            background-image: url(../assets/images/home-footer.jpg);
            background-size: cover;
            background-position: center;
            background-repeat: no-repeat;
            @media (min-width: 992px) {
                width: 100%;
                height: 100%;
                background-image: linear-gradient(to left, #ffff 50%, #fff0 100%), url(../assets/images/home-footer.jpg);
                background-size: auto 100%;
                background-position: top left;
                background-repeat: no-repeat;
                position: absolute;
                z-index: 0;
                top: 0;
                left: 0;
            }
        }
        .apn-container {
            display: flex;
            justify-content: center;
            align-items: center;
            @media (min-width: 992px) {
                position: absolute;
                z-index: 9;
            }

            .box {
                max-width: 500px;
                padding: 40px 10px;
                h2 {
                    text-transform: uppercase;
                    font-size: 20px;
                }
                p {
                    font-weight: 300;
                }
                .apn-btn--more {
                    display: flex;
                    margin: 20px auto 0;
                }
            }
            @media (min-width: 992px) {
                height: 100%;
                display: flex;
                justify-content: flex-end;
                align-items: center;
                .box {
                    width: 100%;
                    max-width: 500px;
                    .apn-btn--more {
                        margin: 20px 0 0;
                    }
                }
            }
        }
    }
}
</style>

